(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusReviewInitiativeAssessmentController', Controller);

    Controller.$inject = ['$scope', '$rootScope', '$state', '$mdToast', 'permissionService', 'businessPlanningService', 'iniativeUpdateStatusReviewService'];

    function Controller($scope, $rootScope, $state, $mdToast, permissionService, businessPlanningService, iniativeUpdateStatusReviewService) {

        var canEdit = permissionService.hasPermission('GRCInitiativeUpdateStatusManagement', 'PlanInitiative', 'ReviewAssessment');

        $scope.readOnly = isReadOnly();
        $scope.ctrlCtxt = {};
        $scope.completionStatuses = [];

        businessPlanningService
            .getPlanLookups()
            .then(function (containerPlanLookups) {
                $scope.completionStatuses = containerPlanLookups.CompletionStatuses;
            });

        // Show Completion Status?
        $scope.showCompletionStatus = function (completionStatus) {
            if (_.isUndefined($scope.planInitiativeAssessment.ReviewCompletionStatusID)) return true;

            return completionStatus.LookupAttributeValueID === $scope.planInitiativeAssessment.ReviewCompletionStatusID;
        };

        // Select Completion Status
        $scope.selectCompletionStatus = function (completionStatus) {
            if ($scope.readOnly) return;

            $scope.pageIsDirty();

            if ($scope.isCompletionStatusSelected()) {
                $scope.planInitiativeAssessment.ReviewCompletionStatusID = undefined;
                $scope.planInitiativeAssessment.ReviewCompletionDate = undefined;
                return;
            }

            $scope.planInitiativeAssessment.ReviewCompletionStatusID = completionStatus.LookupAttributeValueID;

            if ($scope.isFieldRequired('ReviewTargetDate') && _.isUndefined($scope.planInitiativeAssessment.ReviewTargetDate)) {
                $scope.planInitiativeAssessment.ReviewTargetDate = $scope.planInitiativeAssessment.ReviewComputedTargetDate;
            }

        };

        $scope.isCompletionStatusSelected = function () {
            return !_.isUndefined($scope.planInitiativeAssessment.ReviewCompletionStatusID);
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            if ($scope.readOnly) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Show Review & Continue Action?
        $scope.showReviewAndContinueAction = function () {
            if ($scope.readOnly) return false;

            return $scope.isCompletionStatusSelected();
        };

        // Page is dirty
        $scope.ctxtCtrl = {};
        $scope.ctxtCtrl.needSaveChanges = false;
        $scope.ctxtCtrl.isLoading = false;

        $scope.pageIsDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        $scope.pageIsNotDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Reset forms
        $scope.reset = function () {
            if ($scope.readOnly) return;

            $state.reload();

            //iniativeUpdateStatus
            //    .resetPlanInitiativeAssessment($stateParams.ItemPersonID, $scope.planInitiativeAssessment)
            //    .then(function (updatedInitiativeAssessment) {
            //        $state.reload();
            //    });
        };

        // Is Review And Continue Disabled?
        $scope.isReviewAndContinueDisabled = function (form) {
            if ($scope.readOnly) return true;
            if (!$scope.isCompletionStatusSelected()) return true;

            return form.$invalid;
        };

        // Is Field Required?
        $scope.isFieldRequired = function (fieldName) {
            if (_.isUndefined(fieldName)) return false;
            if (_.isUndefined($scope.planInitiativeAssessment.ReviewFieldConditions_ByCompletionStatusID)) return false;

            var conditionsByCompStatusID = $scope.planInitiativeAssessment.ReviewFieldConditions_ByCompletionStatusID;
            var compStatusID = $scope.planInitiativeAssessment.ReviewCompletionStatusID;
            if (_.isNumber(compStatusID)) compStatusID = compStatusID.toString();

            var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];

            if (_.isUndefined(fieldConditions)) return false;

            return fieldConditions['required'];
        };

        // Review and Continue
        $scope.reviewAndContinue = function (form) {
            if ($scope.readOnly) return;

            if ($scope.isReviewAndContinueDisabled(form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                return;
            };
            $scope.ctrlCtxt.showSubmitError = false;

            $scope.ctxtCtrl.isLoading = true;

            iniativeUpdateStatusReviewService
                .reviewPlanInitiative($scope.planInitiativeAssessment)
                .then(function (updatedInitiativeAssessment) {
                    $scope.pageIsNotDirty();

                    $scope.planInitiativeAssessment = updatedInitiativeAssessment;

                    var currentIndex = _.findIndex($scope.initiativesList, {
                        PlanInitiative: { PlanInitiativeID: $scope.planInitiativeAssessment.PlanInitiativeID }
                    });

                    $scope.initiativesList[currentIndex].PlanInitiativeAssessment = updatedInitiativeAssessment;

                    var initiativeToReview = null;

                    if (currentIndex < ($scope.initiativesList.length - 1)) {
                        initiativeToReview = _.find(
                            _.takeRight(
                                $scope.initiativesList,
                                ($scope.initiativesList.length - currentIndex - 1)
                            ),
                            { PlanInitiativeAssessment: { IsReviewed: false } }
                        );
                    }

                    if (!initiativeToReview) {
                        // Check from beginning
                        initiativeToReview = _.find(
                            $scope.initiativesList,
                            { PlanInitiativeAssessment: { IsReviewed: false } }
                        );

                        if (!initiativeToReview) {
                            // All done
                            $mdToast.show(
                                $mdToast
                                    .simple()
                                    .content('All Initiatives have been reviewed')
                                    .position('top right')
                                    .hideDelay($scope.govNotificationDelay)
                                    .action('OK')
                                    .theme('primary')
                            );

                            $state.go('initiativeUpdateStatusOwnerList');

                            return;
                        }
                    }

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Initiative has been reviewed')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverables',
                        { PlanInitiativeID: initiativeToReview.PlanInitiative.PlanInitiativeID }
                    );
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        // Unlock Initiative
        $scope.unlockInitiative = function () {
            if (!$scope.planInitiativeAssessment.IsLocked) return;

            $scope.ctxtCtrl.isLoading = true;

            iniativeUpdateStatusReviewService
                .unlockPlanInitiative($scope.planInitiativeAssessment)
                .then(function (assessmentByAssessor) {
                    var initiativeAssessIdx = _.findIndex($scope.initiativesList, {
                        PlanInitiativeAssessment: { PlanInitiativeAssessmentID: $scope.planInitiativeAssessment.PlanInitiativeAssessmentID }
                    });

                    $scope.planInitiativeAssessment = assessmentByAssessor.PlanInitiativeAssessment;
                    $scope.initiativesList[initiativeAssessIdx] = assessmentByAssessor;
                    $scope.readOnly = isReadOnly();

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Initiative has been unlocked')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $state.reload();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        // Go to Deliverables
        $scope.goToDeliverables = function () {
            $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverables');
        };

        function isReadOnly() {
            if (!canEdit) return true;

            return !$scope.planInitiativeAssessment.IsLocked;
        }
    }

})();